import './DeliveryDate.scss';
import React, {useState} from 'react';
import block from 'bem-cn-lite';
import {Text, Tooltip} from '@gravity-ui/uikit';
import {CircleInfo} from '@gravity-ui/icons';
import {formatDate} from '@utils';
import {useMediaQuery} from 'react-responsive';

const b = block('delivery-date');

export interface DeliveryDateProps {
    value: Date;
    className: string;
    isCustomOrder?: boolean;
    maxValue?: Date;
}

export const DeliveryDate: React.FC<DeliveryDateProps> = (props) => {
    const isMobileScreen = useMediaQuery({query: '(max-width: 1150px)'});
    const [openTooltip, setOpenTooltip] = useState(false);
    const formattedDate = formatDate(props.value, 'DD.MM.YY');
    const formattedMaxDate = props.maxValue ? formatDate(props.maxValue, 'DD.MM.YY') : null;
    const showMobileTooltip = props.isCustomOrder && isMobileScreen;

    const handleDateClick = () => {
        setOpenTooltip(true);
        // setTimeout(() => setOpenTooltip(false), 3000);
    };

    const dateText = <Text variant={'body-2'}>{formattedDate}</Text>;

    return (
        <div
            className={`${b()} ${props.className} ${props.isCustomOrder ? b('custom-order') : ''}`}
        >
            {props.isCustomOrder ? (
                <>
                    {showMobileTooltip ? (
                        <Tooltip
                            content={<Text variant={'body-1'}>Дата доставки</Text>}
                            contentClassName={b('label-tooltip')}
                            className={b('label-tooltip-container')}
                            placement="top-start"
                            openDelay={0}
                            closeDelay={0}
                            disabled={!openTooltip}
                        >
                            <div
                                className={b('date-trigger')}
                                onClick={handleDateClick}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        event.preventDefault();
                                        handleDateClick();
                                    }
                                }}
                            >
                                {dateText}
                            </div>
                        </Tooltip>
                    ) : (
                        dateText
                    )}

                    {formattedMaxDate && (
                        <div className={b('guaranteed-date')}>
                            <Text
                                variant={isMobileScreen ? 'caption-2' : 'body-2'}
                                color={'secondary'}
                            >
                                {formattedMaxDate}
                            </Text>

                            <Tooltip
                                content={
                                    <Text variant={'body-1'}>
                                        Здесь везём издалека. Указаны min и max даты
                                    </Text>
                                }
                                contentClassName={b('guaranteed-tooltip')}
                                className={b('guaranteed-tooltip-container')}
                                placement={isMobileScreen ? 'bottom' : 'top'}
                                openDelay={0}
                                closeDelay={0}
                                disabled={false}
                            >
                                <div className={b('guaranteed-icon-container')}>
                                    <CircleInfo className={b('guaranteed-icon')} />
                                </div>
                            </Tooltip>
                        </div>
                    )}
                </>
            ) : (
                <Text variant={'body-2'} color={'secondary'}>
                    {formattedDate}
                </Text>
            )}
        </div>
    );
};
